import { useEffect } from "react"
import { Route, Routes, useNavigate } from "react-router-dom"
import UsersService from "../API/UsersService"
import { useAccessAPI } from "../hooks/useAccessAPI"
import { useGlobalStore } from "../store/globalStore"

import SiteMenu from "../components/SiteMenu/SiteMenu"
import SiteContentWrapper from "../components/SiteContentWrapper/SiteContentWrapper"
import Modals from "../components/Modals/Modals"
import Main from "../pages/Main"
import Profile from "../pages/Profile/Profile"
import MyStudents from "../pages/MyStudents/MyStudents"
import MyStudentsTests from "../pages/MyStudentsTests/MyStudentsTests"
import MyStudentsProlongations from "../pages/MyStudentsProlongations/MyStudentsProlongations"
import MyStudentsAddsales from "../pages/MyStudentsAddsales/MyStudentsAddsales"
import Duty from "../pages/Duty/Duty"
import DutyStats from "../pages/DutyStats/DutyStats"
import LoadingPage from "../pages/LoadingPage/LoadingPage"
import MyEmployees from "../pages/MyEmployees/MyEmployees"
import AdminContexts from "../pages/AdminContexts/AdminContexts"
import MyEmployeesTests from "../pages/MyEmployeesTests/MyEmployeesTests"
import DutyTestsConducting from "../pages/DutyTestsConducting/DutyTestsConducting"
import DutyTestsRecording from "../pages/DutyTestsRecording/DutyTestsRecording"
import AdminMailingStatuses from "../pages/AdminMailingStatuses/AdminMailingStatuses"
import ProlongationFiles from "../pages/ProlongationFiles/ProlongationFiles"
import CollectingScores from "../pages/CollectingScores/CollectingScores"
import CollectingStatistics from "../pages/CollectingStatistics/CollectingStatistics"

export default function MainRouter() {
    const navigate = useNavigate()
    const [user, setUser, fetchContexts] = useGlobalStore(state => [state.user, state.setUser, state.fetchContexts])
    const getMyself = useAccessAPI(UsersService.getMyself)

    useEffect(() => {
        async function fetchMyself() {
            if (!user || !user?.roles || user?.id === 0) {
                const response = await getMyself()
                if (response?.status === 200) {
                    setUser(response.data)
                    await fetchContexts()
                } else {
                    navigate('/auth')
                }
            }
        }

        fetchMyself()
    }, [])

    if (!user || user?.id === 0)
        return <LoadingPage />

    return (
        <>
            <Modals />
            <SiteMenu />
            <SiteContentWrapper>
                <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/aadmin/mailing-statuses" element={<AdminMailingStatuses />} />
                    <Route path="/aadmin/contexts" element={<AdminContexts />} />
                    <Route path="/mystudents" element={<MyStudents />} />
                    <Route path="/mystudents/tests" element={<MyStudentsTests />} />
                    <Route path="/mystudents/prolongations" element={<MyStudentsProlongations />} />
                    <Route path="/mystudents/addsales" element={<MyStudentsAddsales />} />
                    <Route path="/duty" element={<Duty />} />
                    <Route path="/duty/stats" element={<DutyStats />} />
                    <Route path="/duty/tests/recording" element={<DutyTestsRecording />} />
                    <Route path="/duty/tests/conducting" element={<DutyTestsConducting />} />
                    <Route path="/myemployees" element={<MyEmployees />} />
                    <Route path="/myemployees/tests" element={<MyEmployeesTests />} />
                    <Route path="/analytics/prolongation-files" element={<ProlongationFiles />} />
                    <Route path="/collecting-scores" element={<CollectingScores />} />
                    <Route path="/collecting-scores/stats" element={<CollectingStatistics />} />
                </Routes>
            </SiteContentWrapper>
        </>
    )
}
